import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { $getRouteDataByParam } from '../../utils/get-route-data-by-param.util';
import { MatToolbar } from '@angular/material/toolbar';
import { DatePipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UserProfileMenu } from '@core/layout/topbar/components/user-profile-menu/user-profile-menu';
import { Status } from '../../../shared/components/status/status';
import { Company, CompanyLogo } from '../../../shared/components/company-logo/company-logo';
import { DATE_FORMAT } from '@core/constants/constants';


export interface HeaderState {
  title: string | null;
  subTitle: string | null;
  withDate: boolean;
  company: Company | null;
  selector: string | null;
  status: string | null;
  showNotifications: boolean;
  showUser: boolean;
  withBackButton: string | null;
  backLink: string | null;
}

export const defaultHeaderState = {
  title: null,
  subTitle: null,
  company: null,
  withDate: false,
  selector: null,
  status: null,
  showNotifications: true,
  showUser: true,
  withBackButton: null,
  backLink: null
};
export const HEADER_DATA = 'headerData';

@Component({
  selector: 'app-topbar',
  imports: [MatButtonModule, MatIconModule, MatToolbar, DatePipe, ReactiveFormsModule, UserProfileMenu, Status, CompanyLogo],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Topbar {
  public readonly isMobile = input.required<boolean>();
  public readonly headerInfo = $getRouteDataByParam<HeaderState>(HEADER_DATA, defaultHeaderState);
  public readonly state = computed<HeaderState>(() => ({...defaultHeaderState, ...this.headerInfo()}));
  public readonly toggleMenu = output();
  public today = new Date();
  public readonly selector = new FormControl('');
  protected readonly DATE_FORMAT = DATE_FORMAT;
  // public readonly menuSelector = computed<{ value: string, label: string }[]>(() => {
  //   const selectorLabel = this.state().selector;
  //   if (!selectorLabel) return [];
  //   const variants: Record<string, ISelector[]> = {
  //     providers: [
  //       {value: 'all', label: 'All Providers'},
  //       {value: 'comesa', label: 'YC Comesa'},
  //       {value: 'rawsur', label: 'rawsur'},
  //       {value: 'mubarak', label: 'Mubarak Drizit'},
  //     ]
  //   }
  //
  //   const res = variants?.[selectorLabel as string] || [];
  //   if (res.length) this.selector.setValue(res[0].value || '');
  //   return res;
  // })

}
